// Testing
export const environment = {
    production: true,
    PRIVATE_TESTING: false,

    API_URL: 'https://testing.saideline.com/api/v1',

    localization: {
        defaultLanguage: 'en',
        supportedLanguages: ['en', 'de'],
    },
};
